import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initFaro } from './app/telemetry/faro';

initFaro();


platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    const preloader = document.getElementById('preloader');
    if (preloader) {
      preloader.style.opacity = '0';
      setTimeout(() => preloader.remove(), 500);
    }
  })
  .catch(err => console.error(err));
